import React from 'react';
import './AIFeatures.css';

const AIFeatures = () => {
  const features = [
    {
      icon: '🛰️',
      title: 'Instant Damage Maps',
      description: 'AI analyzes satellite imagery to identify damaged buildings in 3 hours instead of 3 weeks.',
      stat: '100,000+ structures assessed'
    },
    {
      icon: '💬',
      title: '24/7 AI Assistant',
      description: 'Chatbot answers questions in English & Patois anytime. Find shelters, food, medical care instantly.',
      stat: 'Available now →'
    },
    {
      icon: '🎯',
      title: 'Smart Targeting',
      description: 'AI overlays damage + poverty data to prioritize the most vulnerable families first.',
      stat: '2x more efficient'
    },
    {
      icon: '⚡',
      title: 'Fast Applications',
      description: 'Upload a photo, answer 5 questions. AI verifies your damage. Approval in 48 hours.',
      stat: 'Apply in 3 minutes'
    },
    {
      icon: '🔍',
      title: 'Fraud Detection',
      description: 'Computer vision catches fake damage claims. 95% of donations reach real victims.',
      stat: '98% accuracy rate'
    },
    {
      icon: '📊',
      title: 'Full Transparency',
      description: 'Track every dollar donated and distributed on our public dashboard. Trust through technology.',
      stat: 'View dashboard →'
    }
  ];

  return (
    <section className="ai-features">
      <div className="container">
        <div className="section-header">
          <h2>How AI is Accelerating Recovery</h2>
          <p>Five breakthrough technologies working together to get help to Jamaicans faster</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: feature.description }} />
              <div className="feature-stat">{feature.stat}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIFeatures;
